import styled from 'styles/styled';

export const Wrapper = styled.div`

`;

export const ColLeft = styled.div`
  width: calc(100% - 348px);
  @media (max-width: 1020px) {
    width: 100%;
  }
`;

export const ColRight = styled.div`
  width: 340px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media (max-width: 1020px) {
    display: none;
  }
`;

export const RightStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: calc(100vh - 320px);
  height: calc(100svh - 320px);
  min-height: 480px;
  overflow: hidden;

  > *:last-child {
    flex: 1 1 auto;
    min-height: 160px;
  }
`;

export const RightFooterStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
`;

export const AsideBox = styled.div`
  background-color: #15191E;
  width: 100%;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MobileOrderPanelWrap = styled.div`
  margin-top: 8px;
  @media (min-width: 1021px) {
    display: none;
  }
  @media (max-width: 720px) {
    margin-left: 36px;
    margin-right: 36px;
  }
`;

export const Box = styled.div`
  background-color: #15191E;
  width: 100%;
  border-radius: 10px;
  min-height: 600px;
  margin-bottom: 8px;
  height: 100vh;
  max-height: calc(100vh - 65px - 8px);
  max-height: calc(100svh - 65px - 8px);
  @media (max-width: 1020px) {
    max-height: calc(100vh - 90px - 8px);
    max-height: calc(100svh - 90px - 8px);
  }
  @media (min-height: 1000px) {
    max-height: calc(100vh - 282px);
    max-height: calc(100svh - 282px);
  }
  @media (min-height: 1600px) {
    max-height: calc(70vh - 50px - 8px);
    max-height: calc(70svh - 50px - 8px);
  }
  @media (max-width: 720px) {
    min-height: 500px;
  }
  &.boxDetails {
    background-color: transparent;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: calc(100vh - 320px);
    height: calc(100svh - 320px);
    min-height: 480px;
    max-height: none;
    margin-bottom: 0;
    @media (max-width: 720px) {
      max-height: none;
      height: auto;
      min-height: 0;
    }
    @media (max-width: 1020px) {
      @media (max-height: 570px) {
        max-height: 100%;
        height: 100%;
      }
    }
  }
  &.boxDetails.boxEnd {
    height: auto;
    max-height: calc(100vh - 65px - 8px);
    max-height: calc(100svh - 65px - 8px);
    min-height: 600px;
    @media (max-width: 1020px) {
      max-height: calc(100vh - 90px - 8px);
      max-height: calc(100svh - 90px - 8px);
    }
    @media (max-width: 720px) {
      max-height: none;
      height: auto;
      min-height: 500px;
    }
  }
`;

export const RowTop = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const RwdContent = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  @media (max-width: 720px) {
    border-radius: 8px;
    background-color: #15191E;
    padding: 8px 10px;
    flex: 0 0 auto;
  }
`;
